import React, { useState } from 'react';
import { sendHtmlEmail } from "../emailapi"; 
import { 
  FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock, FaFacebookF, 
  FaInstagram, FaTwitter, FaPaperPlane, FaHeart, FaLocationArrow, 
  FaCommentDots, FaShieldAlt, FaStar, FaAward, FaUsers, FaGem, 
  FaWhatsapp, FaArrowRight, FaCheckCircle, FaEdit, FaSave, FaTimes
} from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  
  // Edit mode state for contact details
  const [isEditing, setIsEditing] = useState(false);
  const [contactInfo, setContactInfo] = useState({
    phone: "+91 92356 68748",
    whatsapp: "+91 92356 68748",
    email: "info@balliajewellers.com",
    address: "Q552+39X, Arya Samaj Rd, Okdenganj, Bahadurpur, Ballia, Uttar Pradesh 277001",
    hours: "10:00 AM - 8:30 PM",
    hoursNote: "Open Today · Closes 8:30 PM"
  });
  
  // Map embed URL using the provided address
  const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3599.123456789012!2d84.1456789!3d25.7612345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3992b1234567890%3A0x1234567890abcdef!2sQ552%2B39X%20Arya%20Samaj%20Rd%2C%20Okdenganj%2C%20Bahadurpur%2C%20Ballia%2C%20Uttar%20Pradesh%20277001!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

  };
  
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    await sendHtmlEmail("info@skkjewellers.com", "New Enquiry", formData);

    console.log('Form submitted:', formData);
    setIsSubmitted(true);

    setTimeout(() => setIsSubmitted(false), 3000);
    setFormData({ name: '', email: '', phone: '', message: '' });

  } catch (error) {
    console.error("Email send failed:", error);
    alert("Failed to send message ❌");
  }
};
  

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleContactInfoChange = (e) => {
    setContactInfo({ ...contactInfo, [e.target.name]: e.target.value });
  };

  const handleSaveContactInfo = () => {
    setIsEditing(false);
    // In a real app, you would save to backend here
    alert("Contact information updated successfully!");
  };

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 via-amber-50/20 to-orange-50/30">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-100 to-orange-100 px-5 py-2 rounded-full mb-3 animate-pulse">
            <FaGem className="text-amber-600 w-4 h-4" />
            <span className="text-amber-700 font-semibold text-sm">Get in Touch</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
            Contact <span className="bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent">Us</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-orange-500 mx-auto rounded-full mb-5"></div>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            Visit our showroom in Ballia — <span className="font-semibold text-amber-600">Experience quality firsthand</span>
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          
          {/* Left Section - Contact Info */}
          <div className="space-y-6">
            
            {/* Contact Card with Edit Feature */}
            <div className="bg-white rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-1">
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-3 rounded-xl">
                    <FaCommentDots className="text-white w-5 h-5" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">Get in Touch</h3>
                </div>
                <button 
                  onClick={handleEditToggle}
                  className="flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-100 hover:bg-amber-100 transition group"
                >
                  {isEditing ? (
                    <>
                      <FaTimes className="text-red-500 group-hover:rotate-90 transition" />
                      <span className="text-sm font-medium text-red-500">Cancel</span>
                    </>
                  ) : (
                    <>
                      <FaEdit className="text-amber-600 group-hover:rotate-12 transition" />
                      <span className="text-sm font-medium text-amber-600">Edit Info</span>
                    </>
                  )}
                </button>
              </div>
              
              <div className="space-y-4">
                {/* Phone */}
                <div className="flex items-start gap-4 p-3 rounded-xl group hover:bg-amber-50 cursor-pointer transition-all duration-300">
                  <div className="bg-amber-100 p-3 rounded-full group-hover:bg-amber-600 transition-all group-hover:scale-110">
                    <FaPhoneAlt className="text-amber-600 group-hover:text-white w-4 h-4" />
                  </div>
                  <div className="flex-1">
                    <p className="text-xs text-gray-500">Call Us Anytime</p>
                    {isEditing ? (
                      <input
                        type="text"
                        name="phone"
                        value={contactInfo.phone}
                        onChange={handleContactInfoChange}
                        className="text-lg font-bold text-gray-800 bg-amber-50 border border-amber-300 rounded px-2 py-1 w-full"
                      />
                    ) : (
                      <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="text-lg font-bold text-gray-800 hover:text-amber-600">
                        {contactInfo.phone}
                      </a>
                    )}
                  </div>
                </div>

                {/* WhatsApp */}
                <div className="flex items-start gap-4 p-3 rounded-xl group hover:bg-green-50 cursor-pointer transition-all duration-300">
                  <div className="bg-green-100 p-3 rounded-full group-hover:bg-green-600 transition-all group-hover:scale-110">
                    <FaWhatsapp className="text-green-600 group-hover:text-white w-4 h-4" />
                  </div>
                  <div className="flex-1">
                    <p className="text-xs text-gray-500">WhatsApp Us</p>
                    {isEditing ? (
                      <input
                        type="text"
                        name="whatsapp"
                        value={contactInfo.whatsapp}
                        onChange={handleContactInfoChange}
                        className="text-lg font-bold text-gray-800 bg-amber-50 border border-amber-300 rounded px-2 py-1 w-full"
                      />
                    ) : (
                      <a href={`https://wa.me/${contactInfo.whatsapp.replace(/\s/g, '')}`} className="text-lg font-bold text-gray-800 hover:text-green-600">
                        {contactInfo.whatsapp}
                      </a>
                    )}
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start gap-4 p-3 rounded-xl group hover:bg-amber-50 cursor-pointer transition-all duration-300">
                  <div className="bg-amber-100 p-3 rounded-full group-hover:bg-amber-600 transition-all group-hover:scale-110">
                    <FaEnvelope className="text-amber-600 group-hover:text-white w-4 h-4" />
                  </div>
                  <div className="flex-1">
                    <p className="text-xs text-gray-500">Email Us</p>
                    {isEditing ? (
                      <input
                        type="email"
                        name="email"
                        value={contactInfo.email}
                        onChange={handleContactInfoChange}
                        className="text-lg font-bold text-gray-800 bg-amber-50 border border-amber-300 rounded px-2 py-1 w-full"
                      />
                    ) : (
                      <a href={`mailto:${contactInfo.email}`} className="text-lg font-bold text-gray-800 hover:text-amber-600">
                        {contactInfo.email}
                      </a>
                    )}
                  </div>
                </div>

                {/* Address */}
                <div className="flex items-start gap-4 p-3 rounded-xl group hover:bg-amber-50 cursor-pointer transition-all duration-300">
                  <div className="bg-amber-100 p-3 rounded-full group-hover:bg-amber-600 transition-all group-hover:scale-110">
                    <FaMapMarkerAlt className="text-amber-600 group-hover:text-white w-4 h-4" />
                  </div>
                  <div className="flex-1">
                    <p className="text-xs text-gray-500">Visit Our Store</p>
                    {isEditing ? (
                      <textarea
                        name="address"
                        value={contactInfo.address}
                        onChange={handleContactInfoChange}
                        rows={2}
                        className="text-gray-800 text-sm font-medium bg-amber-50 border border-amber-300 rounded px-2 py-1 w-full"
                      />
                    ) : (
                      <p className="text-gray-800 text-sm font-medium">
                        {contactInfo.address}
                      </p>
                    )}
                  </div>
                </div>

                {/* Timing */}
                <div className="flex items-start gap-4 p-3 rounded-xl group hover:bg-amber-50 cursor-pointer transition-all duration-300">
                  <div className="bg-amber-100 p-3 rounded-full group-hover:bg-amber-600 transition-all group-hover:scale-110">
                    <FaClock className="text-amber-600 group-hover:text-white w-4 h-4" />
                  </div>
                  <div className="flex-1">
                    <p className="text-xs text-gray-500">Opening Hours</p>
                    {isEditing ? (
                      <>
                        <input
                          type="text"
                          name="hours"
                          value={contactInfo.hours}
                          onChange={handleContactInfoChange}
                          className="text-gray-800 font-bold bg-amber-50 border border-amber-300 rounded px-2 py-1 w-full mb-1"
                        />
                        <input
                          type="text"
                          name="hoursNote"
                          value={contactInfo.hoursNote}
                          onChange={handleContactInfoChange}
                          className="text-xs text-green-600 bg-amber-50 border border-amber-300 rounded px-2 py-1 w-full"
                        />
                      </>
                    ) : (
                      <>
                        <p className="text-gray-800 font-bold">{contactInfo.hours}</p>
                        <p className="text-xs text-green-600 mt-1 flex items-center gap-1">
                          <FaCheckCircle className="w-3 h-3" /> {contactInfo.hoursNote}
                        </p>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* Save Button when editing */}
              {isEditing && (
                <button
                  onClick={handleSaveContactInfo}
                  className="mt-6 w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-2 rounded-xl font-bold hover:scale-[1.02] transition flex items-center justify-center gap-2 group"
                >
                  <FaSave className="group-hover:rotate-12 transition" /> Save Changes
                </button>
              )}

              {/* Social Links */}
              <div className="mt-8 pt-6 border-t">
                <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                  <FaHeart className="text-amber-500 animate-pulse" /> Connect With Us
                </h4>
                <div className="flex gap-3">
                  <a href="#" className="bg-blue-600 text-white p-3 rounded-full hover:scale-110 hover:rotate-12 transition-all duration-300 shadow-md">
                    <FaFacebookF className="w-4 h-4" />
                  </a>
                  <a href="#" className="bg-gradient-to-r from-pink-500 to-orange-500 text-white p-3 rounded-full hover:scale-110 hover:rotate-12 transition-all duration-300 shadow-md">
                    <FaInstagram className="w-4 h-4" />
                  </a>
                  <a href="#" className="bg-blue-400 text-white p-3 rounded-full hover:scale-110 hover:rotate-12 transition-all duration-300 shadow-md">
                    <FaTwitter className="w-4 h-4" />
                  </a>
                  <a href="#" className="bg-green-600 text-white p-3 rounded-full hover:scale-110 hover:rotate-12 transition-all duration-300 shadow-md">
                    <FaWhatsapp className="w-4 h-4" />
                  </a>
                </div>
              </div>
            </div>

            {/* Features Grid */}
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-gradient-to-br from-amber-500 to-amber-600 text-white p-4 rounded-xl text-center hover:scale-105 hover:rotate-1 transition-all duration-300 shadow-md">
                <div className="bg-white/20 w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-2 animate-bounce">
                  <FaStar className="w-5 h-5" />
                </div>
                <p className="font-bold text-sm">Quality Products</p>
                <p className="text-xs opacity-90">Certified Jewellery</p>
              </div>
              <div className="bg-gradient-to-br from-orange-500 to-orange-600 text-white p-4 rounded-xl text-center hover:scale-105 hover:-rotate-1 transition-all duration-300 shadow-md">
                <div className="bg-white/20 w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-2">
                  <FaAward className="w-5 h-5" />
                </div>
                <p className="font-bold text-sm">Best Price</p>
                <p className="text-xs opacity-90">Guaranteed</p>
              </div>
              <div className="bg-gradient-to-br from-green-500 to-green-600 text-white p-4 rounded-xl text-center hover:scale-105 transition-all duration-300 shadow-md">
                <div className="bg-white/20 w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-2">
                  <FaUsers className="w-5 h-5" />
                </div>
                <p className="font-bold text-sm">Expert Staff</p>
                <p className="text-xs opacity-90">Guidance Available</p>
              </div>
              <div className="bg-gradient-to-br from-purple-500 to-purple-600 text-white p-4 rounded-xl text-center hover:scale-105 transition-all duration-300 shadow-md">
                <div className="bg-white/20 w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-2">
                  <FaShieldAlt className="w-5 h-5" />
                </div>
                <p className="font-bold text-sm">Easy Exchange</p>
                <p className="text-xs opacity-90">Lifetime Policy</p>
              </div>
            </div>

            {/* Store Notice */}
            <div className="bg-gradient-to-r from-amber-50 to-orange-50 border-l-4 border-amber-500 rounded-xl p-4 hover:shadow-lg transition-all duration-300">
              <div className="flex items-start gap-3">
                <div className="bg-amber-500 p-2 rounded-full animate-pulse">
                  <FaHeart className="text-white w-4 h-4" />
                </div>
                <div>
                  <p className="font-bold text-amber-800 text-sm">📍 Visit Our Physical Store</p>
                  <p className="text-xs text-amber-700">Walk-ins are always welcome!</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section - Form & Map */}
          <div className="space-y-6">
            
            {/* Contact Form */}
            <div className="bg-white rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-1">
              <div className="flex items-center gap-3 mb-6">
                <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-3 rounded-xl animate-pulse">
                  <FaPaperPlane className="text-white w-5 h-5" />
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Send Message</h3>
              </div>
              
              <form onSubmit={handleSubmit} className="space-y-4">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-amber-500 bg-gray-50 focus:bg-white transition-all duration-300 hover:shadow-md"
                  placeholder="Your Name *"
                />

                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-amber-500 bg-gray-50 focus:bg-white transition-all duration-300 hover:shadow-md"
                  placeholder="Email Address *"
                />

                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-amber-500 bg-gray-50 focus:bg-white transition-all duration-300 hover:shadow-md"
                  placeholder="Phone Number *"
                />

                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="4"
                  className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-amber-500 bg-gray-50 focus:bg-white resize-none transition-all duration-300 hover:shadow-md"
                  placeholder="Your Message *"
                />

                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-amber-500 to-orange-600 text-white py-3 rounded-xl font-bold hover:scale-[1.02] hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2 group"
                >
                  Send Message <FaArrowRight className="group-hover:translate-x-2 transition-transform duration-300" />
                </button>

                {isSubmitted && (
                  <div className="bg-green-100 text-green-700 p-3 rounded-xl text-center font-medium animate-bounce">
                    ✓ Message sent successfully!
                  </div>
                )}
              </form>
            </div>

            {/* Google Maps - Updated with correct location */}
            <div className="bg-white rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all duration-500">
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-3 rounded-xl">
                  <FaLocationArrow className="text-white w-5 h-5" />
                </div>
                <h4 className="text-lg font-bold text-gray-800">Find Us</h4>
              </div>
              <div className="rounded-xl overflow-hidden h-64 hover:shadow-lg transition-all duration-300">
                <iframe
                  title="SKJ Jewellers Ballia Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3599.456789012345!2d84.1456789!3d25.7612345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3992b1a2b3c4d5e6%3A0x1234567890abcdef!2sQ552%2B39X%2C%20Arya%20Samaj%20Rd%2C%20Okdenganj%2C%20Bahadurpur%2C%20Ballia%2C%20Uttar%20Pradesh%20277001!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <p className="text-sm text-gray-600 text-center mt-4 flex items-center justify-center gap-2">
                <FaMapMarkerAlt className="text-amber-500" />
                Q552+39X, Arya Samaj Rd, Okdenganj, Bahadurpur, Ballia, UP 277001
              </p>
            </div>

            {/* Quick Info */}
            <div className="bg-amber-50 rounded-xl p-4 border border-amber-200 hover:shadow-md transition-all duration-300">
              <p className="text-sm font-bold text-gray-800 flex items-center gap-2">
                <FaHeart className="text-amber-500" /> Nearby Landmarks:
              </p>
              <p className="text-xs text-gray-600 mt-1">PNB ATM • Arya Samaj Road Main Market • Ballia City Center • Okdenganj Chowk</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;